import styled from 'styled-components';
import { mq, getGridSpans, getSpace, getColor } from '../../../stylesheets/tools';

const StyledCampaignStage = styled.section`
  position: relative;
  display: block;
  width: 100%;
  margin-bottom: ${getSpace('l')};

  .campaignStage__wrapper {
    position: relative;
    width: 100%;
    display: flex;
    flex-direction: column;
    overflow: hidden;

    ${mq('l')} {
      flex-direction: row;
      aspect-ratio: 16/9;
      height: 100%;
      max-height: 100vh;

      @supports not (aspect-ratio: 16 / 9) {
        width: 100%;
        height: 100vh;
      }
    }

    > div:last-child {
      position: absolute;
      left: 0;
      top: 0;
      padding-top: max(20vw, 120px);
      ${mq('l')} {
        padding-top: 0;
        top: 50%;
        transform: translateY(-50%);
      }
    }

    .container__wrapper {
      height: 100%;
      width: auto;
      display: flex;
      flex-direction: column;
      justify-content: center;

      ${mq('l')} {
        width: 40%;
      }

      ${mq('xl')} {
        width: 50%;
      }
    }
  }

  .campaignStage__media {
    width: 100%;
    height: min-content;
    min-height: 100vh;
    display: flex;
    justify-content: center;
    align-items: flex-end;

    ${mq('l')} {
      height: 100%;
      align-items: center;
    }

    &--desktop {
      display: none;

      ${mq('l')} {
        display: block;
      }
    }

    &--mobile {
      display: block;
      ${mq('l')} {
        display: none;
      }
    }

    img,
    video {
      width: 100%;
      height: 100%;
      object-fit: cover;
      position: absolute;
      bottom: 0;
    }
  }

  .campaignStage__headline {
    color: ${getColor('white')};
    padding: ${getSpace('xs')};
    ${getGridSpans('margin-left', { s: 0, m: [1, 'spread'], l: 0 })};
    ${getGridSpans('width', { s: 12, m: 10, l: 12 })};

    & > div > p {
      margin-top: ${getSpace('m')};
      margin-bottom: ${getSpace('m')};

      ${mq('m')} {
        margin-top: ${getSpace('m')};
        margin-bottom: ${getSpace('l')};
      }
    }
    ${mq('m')} {
      padding: 0;
    }

    ${mq('l')} {
      & > div > p,
      & > .campaignStage__link {
        margin-left: ${getSpace('l')};
      }
    }
  }

  .campaignStage__subline,
  .campaignStage__copy {
    position: relative;
    margin: 0;
    ${getGridSpans('margin-left', { s: [1, 'spread'] })}
    ${getGridSpans('margin-right', { s: [1, 'spread'] })}
    padding-left: 2px;
    display: block;
    z-index: 2;
  }

  .campaignStage__link {
    display: flex;
    align-items: center;
    justify-content: flex-start;

    svg {
      margin-right: ${getSpace('xxs')};
    }
  }

  .mainStage__curtain-right,
  .mainStage__curtain-left {
    position: fixed;
    height: 120vh;
    box-shadow: 0px 0px 10px 3px rgba(0, 0, 0, 0.1);
    z-index: 1;
    transition: transform 0.2s cubic-bezier(0.48, 0, 0.5, 1);
  }

  .mainStage__curtain-left {
    width: 150vw;
    top: 70vh;
    left: 0;
    transform: translateY(100%) rotate(15deg);
    transform-origin: top left;
    background: ${props => props.theme.globalTheme.secondary};

    ${mq('l')} {
      top: 60vh;
    }
  }

  .mainStage__curtain-right {
    height: 120vh;
    width: 150vw;
    top: 50vh;
    right: 0;
    left: auto;
    transform: translateY(100%) rotate(-50deg);
    transform-origin: top right;
    background: ${props => props.theme.globalTheme.tertiary};

    ${mq('l')} {
      height: 120vh;
      width: 150vw;
      top: -20vh;
      right: 0;
    }
  }
`;

export default StyledCampaignStage;
